import { Chip, ChipOwnProps } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ClipboardImage from '../../assets/images/3d-icons/clipboard.png';
import { ContractPricingInfo } from '../utils/contracts.utils';

export interface CatalogChipProps {
  contract: ContractPricingInfo;
  color?: ChipOwnProps['color'];
  variant?: ChipOwnProps['variant'];
}

export default function CatalogChip({ contract, color, variant = 'outlinedTag' }: CatalogChipProps): React.JSX.Element {
  const { t } = useTranslation(['catalogs']);

  const label = useMemo((): string => {
    return contract.sub_catalog?.name || t('catalogs:default_catalog');
  }, [contract]);

  return (
    <Chip
      label={label}
      variant={variant}
      icon={<img src={ClipboardImage} height="20" width="20" />}
      color={color}
    />
  );
}
